import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import CommonDialog from '@src/new-components/Dialog/CommonDialog';
import Typography from '@src/new-components/Typography';
import CommonSwitch from '@src/new-components/Switch';
import CommonButton from '@src/new-components/Button';
import { COLOR } from '@src/styles/color';
import {
  InfoBox,
  StyledDenoiseDialog,
  ToggleLabel,
  ToggleRow,
} from './index.style';

const DenoiseDialog = ({
  audioId,
  onClose,
  onSave,
  initialEnabled = false,
  loading = false,
}) => {
  const { t } = useTranslation();
  const [isEnabled, setIsEnabled] = useState(initialEnabled);

  useEffect(() => {
    setIsEnabled(initialEnabled);
  }, [initialEnabled, audioId]);

  const handleSave = () => {
    if (!audioId) return;
    onSave?.({
      audioId,
      denoise: isEnabled,
    });
  };

  const contentComponent = useMemo(
    () => (
      <StyledDenoiseDialog>
        <ToggleRow>
          <ToggleLabel>
            <Typography variant="body-16-medium" color={COLOR.darkGray}>
              {t('noiseReduction')}
            </Typography>
          </ToggleLabel>
          <CommonSwitch
            variant="ios"
            checked={isEnabled}
            onChange={(_, checked) => setIsEnabled(checked)}
          />
        </ToggleRow>
        <InfoBox>
          <InfoRoundedIcon className="info-icon" />
          <Typography variant="body-14-regular" color={COLOR.darkGray}>
            {t('denoiseDescription')}
          </Typography>
        </InfoBox>
      </StyledDenoiseDialog>
    ),
    [isEnabled, t],
  );

  const actionComponent = (
    <>
      <CommonButton
        variant="outlineSmall"
        onClick={onClose}
        customStyle={{ height: '40px', minWidth: '88px', borderRadius: '8px' }}
        textProps={{ variantText: 'body-14-semibold', color: COLOR.darkBlue }}
      >
        {t('cancel')}
      </CommonButton>
      <CommonButton
        variant="contained"
        onClick={handleSave}
        disabled={loading}
        customStyle={{ height: '40px', minWidth: '132px', borderRadius: '8px' }}
        textProps={{ variantText: 'body-14-semibold', color: COLOR.darkBlue }}
      >
        {t('saveChange')}
      </CommonButton>
    </>
  );

  return (
    <CommonDialog
      open={Boolean(audioId)}
      onClose={onClose}
      title={t('denoiseSettingsTitle')}
      contentComponent={contentComponent}
      actionComponent={actionComponent}
      width="640px"
    />
  );
};

export default DenoiseDialog;
